import { ArrowBack, ArrowForward } from "@mui/icons-material";
import { Box, Typography, Button } from "@mui/material";
import { t } from "i18next";
import React, { useRef } from "react";
import Images from "../../constant/images";
import Icon from "../Elements/Icon/Icon";
import "./../../screens/Service/Service.css";
import "./../../screens/Home/Home.css";
import Card from "../Elements/Card/Card";
import "./Carousel.css"; // Custom CSS file

export const ClientTestimonial = () => {
  const scrollContainer = useRef<HTMLDivElement | null>(null);

  const cards = [
    {
      number: "1",
      title: "Employee Records Management",
      points: [
        "Maintaining accurate and up-to-date records for all employees (e.g., personal details, employment history, benefits enrollment, performance appraisals).",
      ],
    },
    {
      number: "2",
      title: "Payroll Administration:",
      points: [
        "Managing employee salaries, benefits, bonuses, and ensuring timely payment.",
        " Handling tax deductions, overtime, and bonuses.",
      ],
    },
    {
      number: "3",
      title: "Administration benefits:",
      points: [
        "Managing employee benefits programs such as health insurance, retirement plans, and vacation policies.",
        "Ensuring that employees are enrolled in the appropriate benefit plans.",
      ],
    },
    {
      number: "4",
      title: "Compliance and Legal Documentation:",
      points: [
        "Ensuring that the company adheres to labor laws, health and safety regulations, and other  legal requirements.",
        "Managing employment contracts, termination letters, and other documentation.",
      ],
    },
    {
      number: "5",
      title: "Policy and Procedure Development:",
      points: [
        "Drafting and communicating company policies on issues like attendance, dress code, harassment, and code of conduct.",
      ],
    },
    {
      number: "6",
      title: "Employee Leave Management:",
      points: [
        "Tracking employee leave (sick leave, vacation, parental leave) and ensuring compliance with company policies.",
      ],
    },
    {
      number: "7",
      title: "HR Systems Management:",
      points: [
        "Using HR software to manage employee data, payroll, and benefits administration.",
      ],
    },
    {
      number: "8",
      title: "Reporting and Data Management:",
      points: [
        "Preparing regular reports on HR activities, such as employee turnover, payroll, and compliance audits.",
      ],
    },
  ];

  const handleScroll = (direction: "left" | "right") => {
    const container = scrollContainer.current;
    if (container) {
      if (direction === "left") {
        const scrollAmount = window.innerWidth > 768 ? 400 : 250; // Adjust for screen size
        container.scrollBy({
          left: direction === "left" ? -scrollAmount : scrollAmount,
          behavior: "smooth",
        });

        // container.scrollBy({ left: -300, behavior: "smooth" });
      } else {
        container.scrollBy({ left: 300, behavior: "smooth" });
      }
    }
  };
  return (
    <>
      <Box className="client-testimonial">
        <Box className="client-testimonial-box">
          <Typography
            variant="h5"
            textAlign={"left"}
            className="process-title"
            // textTransform={"uppercase"}
          >
            {/* {t("home.Client")} */}
            Administration part of HR:
          </Typography>

          <Typography
            className="service-card-paragraph"
            mb={4}
            // lineHeight={"35px !important"}
          >
            {/* {t("hrSolution.section1")} */}
            HR administration ensures the efficient running of HR functions and
            supports the HR department in its strategic goals. It’s about
            maintaining smooth operations and compliance with all relevant
            regulations.
          </Typography>
        </Box>
      </Box>
      <Box className="desktop-arrow">
        <Button
          variant="contained"
          onClick={() => handleScroll("left")}
          sx={{
            minWidth: { xs: "40px", md: "50px" },
            height: { xs: "40px", md: "50px" },
            borderRadius: "50%",
            bgcolor: "#E4DEEB",
            padding: { xs: "0px" },
          }}
        >
          <ArrowBack />
        </Button>
        <Button
          variant="contained"
          onClick={() => handleScroll("right")}
          sx={{
            minWidth: { xs: "40px", md: "50px" },
            height: { xs: "40px", md: "50px" },
            borderRadius: "50%",
            bgcolor: "#721372",
            ml: 2,
            padding: { xs: "0px" },
          }}
        >
          <ArrowForward />
        </Button>
      </Box>
      <Box className="client-testimonial-card">
        <Box ref={scrollContainer} className="client-testimonial-scroll">
          {cards.map((card, index) => (
            <Card key={index} className={"service-cards2"}>
              <Box display={"flex"} gap={2}>
                <Box className="step-number">{card.number}</Box>
                <Typography className="card-title">{card.title}</Typography>
              </Box>
              <ul className="card-list">
                {card.points.map((point, i) => (
                  <li key={i} className="card-para">
                    {point}
                  </li>
                ))}
              </ul>
            </Card>
          ))}
        </Box>
      </Box>
      <Box className="mobile-arrow">
        <Button
          variant="contained"
          onClick={() => handleScroll("left")}
          sx={{
            minWidth: { xs: "40px", md: "50px" },
            height: { xs: "40px", md: "50px" },
            borderRadius: "50%",
            bgcolor: "#E4DEEB",
            padding: { xs: "0px" },
          }}
        >
          <ArrowBack />
        </Button>
        <Button
          variant="contained"
          onClick={() => handleScroll("right")}
          sx={{
            minWidth: { xs: "40px", md: "50px" },
            height: { xs: "40px", md: "50px" },
            borderRadius: "50%",
            bgcolor: "#721372",
            ml: 2,
            padding: { xs: "0px" },
          }}
        >
          <ArrowForward />
        </Button>
      </Box>
      {/* <Box mt={"-20px"} ml={"35px"} mb={5}>
        <Button
          variant="contained"
          onClick={() => handleScroll("left")}
          sx={{
            minWidth: "50px",
            height: "50px",
            borderRadius: "50%",
            bgcolor: "#E4DEEB",
          }}
        >
          <ArrowBack />
        </Button>
        <Button
          variant="contained"
          onClick={() => handleScroll("right")}
          sx={{
            minWidth: "50px",
            height: "50px",
            borderRadius: "50%",
            bgcolor: "#721372",
            ml: 2,
          }}
        >
          <ArrowForward />
        </Button>
      </Box> */}
    </>
  );
};
